/*
 * (c) Copyright, 2026, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useNavigate } from 'react-router'
import { useServiceContext } from '~/root'

interface LinkedFilesModalProps {
  documentsList: Array<{ id: number; name: string }>
  onClose: () => void
}

export default function LinkedFilesModal({ documentsList, onClose }: LinkedFilesModalProps) {
  const navigate = useNavigate()
  const context = useServiceContext()
  const translate = context.service.filter.translate

  const dismiss = () => {
    onClose()
  }

  const handleFileClick = (fileId: number) => {
    dismiss()
    navigate(`/show-file/${fileId}`)
  }

  const excerpt = (text: string, stripHtml: boolean, maxLength: number): string => {
    if (!text) return ''
    if (text.length <= maxLength) return text
    return text.substring(0, maxLength) + '...'
  }

  return (
    <div id="modal-add-file" className="justi-desc-info-modal">
      <div className="modal-header">
        <h3 className="modal-title">{translate('DOCUMENTS')}</h3>
        <i className="close-modal" onClick={dismiss}></i>
      </div>
      <div className="modal-body">
        <label>{translate('DOCUMENTS')}</label>
        <div className="info" style={{ maxHeight: '495px', overflowY: 'auto' }}>
          {documentsList.map((file) => (
            <div key={file.id}>
              <a onClick={() => handleFileClick(file.id)} title={String(file.id)} style={{ cursor: 'pointer' }}>
                {excerpt(file.name, false, 85)}
              </a>
            </div>
          ))}
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-primary" type="button" onClick={dismiss}>
          {translate('OK')}
        </button>
      </div>
    </div>
  )
}
